import React from "react";
import { Stack } from "@mui/material";
import ClearCallLoadingLogo from "../../components/clear-call-loading-logo";
import ribbonBackground from "../../assets/ribbon.png";

const MeetingLoadingPage: React.FC = () => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: "100vh",
        backgroundImage:
          `linear-gradient(160deg, rgba(0, 28, 29, 0.73), rgba(0, 39, 66, 0.98)), url(${ribbonBackground})`,
        backgroundBlendMode: "normal",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <ClearCallLoadingLogo />
    </Stack>
  );
};

export default MeetingLoadingPage;
